import mitt from 'mitt'

// mitt возвращает объект с методами: on, off, emit
export const EventBus = mitt()
